import * as slides from './components/slides'
export { slides }

export { default as DynamicSlide } from './components/DynamicSlide.vue'
export { default as Countdown } from './components/Countdown.vue'
export { default as Quiz } from './components/Quiz'
export { createSubscriber } from './utils/create-subscriber'
export const SlideBase = slides.SlideBase
